<template>
  <div class="fill-height">
    <v-container v-if="error" fill-height>
      <Error />
    </v-container>

    <div v-else>
      <v-row class="ma-0 pa-4">
        <v-col
          cols="12"
          md="8"
          lg="9"
          :order="$vuetify.breakpoint.xs ? 'last' : 'first'"
        >
          <introduction
            v-if="
              introduction && !onGoingCourses.length 
            "
          />

          <template v-else>
            <ongoing-course-list
              :data="onGoingCourses"
              :loading="loading"
              class="mb-10"
            />

            <assigned-course-list
              :data="assignedCourses"
              :loading="loading"
              class="mb-10"
            />

            <achievement-list class="mb-10" />
          </template>
        </v-col>

        <v-col
          cols="12"
          md="4"
          lg="3"
          :order="$vuetify.breakpoint.xs ? 'first' : 'last'"
        >
          <alert-list
            v-if="activeCourses && activeCourses.length"
            :courses="activeCourses"
            class="mb-10"
          />

          <my-profile-list class="mb-10" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Error from "../components/Error.vue";
import OngoingCourseList from "../../course-module/components/OngoingCourseList.vue";
import AssignedCourseList from "../../course-module/components/AssignedCourseList.vue";
import AchievementList from "../../user-module/components/Dashboard/AchievementList.vue";
import MyProfileList from "../../user-module/components/Dashboard/MyProfileList.vue";
import AlertList from "../components/AlertList.vue";
import Introduction from "../components/Introduction.vue";

import { authUser } from "../../user-module/helpers/authHelper";

export default {
  components: {
    OngoingCourseList,
    AssignedCourseList,
    AchievementList,
    MyProfileList,
    AlertList,
    Error,
    Introduction,
  },
  data() {
    return {
      error: false,
      loading: true,
      introduction: false,
      variables: {
        limit: 0,
        skip: 0,
      },
      filterInput: {
        dateFrom: "",
        dateTo: "",
      },
      data: [],
      onGoingCourses: [],
      assignedCourses: [],
      activeCourses: [],
    };
  },
  created() {
    var parseData = new Date(parseInt(authUser().createdAt));
    var today = new Date();
    var time_difference = today.getTime() - parseData.getTime();
    var days_difference = Math.trunc(time_difference / (1000 * 60 * 60 * 24));
    if (days_difference < 1) this.introduction = true;
  },
  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../../course-module/api/query/getTrainingRegistrations.gql"),
        variables: {
          limit: this.variables.limit,
          skip: this.variables.skip,
        },
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.onGoingCourses = [];
            this.assignedCourses = [];
            this.activeCourses = [];

            data.getTrainingRegistrations.trainingRegistrations.map(obj => {
              if (obj.status === "STARTED") {
                this.onGoingCourses.push(obj);
                this.activeCourses.push(obj);
              } else if (obj.status === "REGISTERED") {
                this.assignedCourses.push(obj);
                this.activeCourses.push(obj);
              }
            });
          } else {
            this.error = true;
          }

          this.loading = loading;
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped />
